var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewmenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.086 2.66666H10.9127C6.05935 2.66666 3.16602 5.55999 3.16602 10.4133V21.5733C3.16602 26.44 6.05935 29.3333 10.9127 29.3333H22.0727C26.926 29.3333 29.8193 26.44 29.8193 21.5867V10.4133C29.8327 5.55999 26.9394 2.66666 22.086 2.66666ZM23.166 23H9.83268C9.28602 23 8.83268 22.5467 8.83268 22C8.83268 21.4533 9.28602 21 9.83268 21H23.166C23.7127 21 24.166 21.4533 24.166 22C24.166 22.5467 23.7127 23 23.166 23ZM23.166 17H9.83268C9.28602 17 8.83268 16.5467 8.83268 16C8.83268 15.4533 9.28602 15 9.83268 15H23.166C23.7127 15 24.166 15.4533 24.166 16C24.166 16.5467 23.7127 17 23.166 17ZM23.166 11H9.83268C9.28602 11 8.83268 10.5467 8.83268 9.99999C8.83268 9.45332 9.28602 8.99999 9.83268 8.99999H23.166C23.7127 8.99999 24.166 9.45332 24.166 9.99999C24.166 10.5467 23.7127 11 23.166 11Z",
    fill: "#28A5DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewmenu);
export default __webpack_public_path__ + "static/media/newmenu.0677625fc24e2ed9938f84cdebd32f26.svg";
export { ForwardRef as ReactComponent };